import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { MyFitnessWidgetConfigDocument, type MyFitnessWidgetConfigQuery } from '@/graphql/generated/graphql';

export type FitnessWidgetConfig = MyFitnessWidgetConfigQuery['myFitnessWidgetConfig'];

export async function requestFitnessWidgetConfig(): Promise<FitnessWidgetConfig> {
  const data = await gqlRequest(MyFitnessWidgetConfigDocument);
  return data.myFitnessWidgetConfig;
}
